// import React from 'react';
// import { Box, CircularProgress, Fade } from '@mui/material';
// import logo from '../Images/BizBridge-Logo-1.png';

// const LoadingScreen = () => {
//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         bgcolor: '#0A1929', // Dark blue background matching your theme
//         zIndex: 9999,
//       }}
//     >
//       <Fade in timeout={1000}>
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             gap: 4,
//           }}
//         >
//           {/* Logo with animation */}
//           <Box
//             component="img"
//             src={logo}
//             alt="BizBridge Logo"
//             sx={{
//               width: { xs: '180px', sm: '220px', md: '280px' },
//               height: 'auto',
//               animation: 'pulse 2s ease-in-out infinite',
//               '@keyframes pulse': {
//                 '0%, 100%': {
//                   transform: 'scale(1)',
//                   opacity: 1,
//                 },
//                 '50%': {
//                   transform: 'scale(1.05)',
//                   opacity: 0.9,
//                 },
//               },
//             }}
//           />
          
//           {/* Loading spinner */}
//           <CircularProgress
//             size={50}
//             thickness={4}
//             sx={{
//               color: '#25D366', // WhatsApp green color
//               marginTop: 2,
//             }}
//           />
          
//           {/* Optional loading text */}
//           <Box
//             sx={{
//               color: '#B2B9C5',
//               fontSize: '0.9rem',
//               fontWeight: 500,
//               letterSpacing: '1px',
//               textTransform: 'uppercase',
//               marginTop: 1,
//             }}
//           >
//             Loading...
//           </Box>
//         </Box>
//       </Fade>
//     </Box>
//   );
// };

// export default LoadingScreen;

import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, Fade } from '@mui/material';
import logo from '../Images/BizBridge-Logo-1.png';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 100;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0A1929',
        zIndex: 9999,
      }}
    >
      <Fade in timeout={1000}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
            width: '100%',
            maxWidth: '400px',
            px: 3,
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={logo}
            alt="BizBridge Logo"
            sx={{
              width: { xs: '180px', sm: '220px', md: '280px' },
              height: 'auto',
              animation: 'float 3s ease-in-out infinite',
              '@keyframes float': {
                '0%, 100%': {
                  transform: 'translateY(0)',
                },
                '50%': {
                  transform: 'translateY(-10px)',
                },
              },
            }}
          />
          
          {/* Progress Bar */}
          <Box sx={{ width: '100%', mt: 4 }}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 6,
                borderRadius: 3,
                bgcolor: 'rgba(37, 211, 102, 0.1)',
                '& .MuiLinearProgress-bar': {
                  bgcolor: '#25D366',
                  borderRadius: 3,
                },
              }}
            />
          </Box>
          
          {/* Loading text with dots animation */}
          <Box
            sx={{
              color: '#B2B9C5',
              fontSize: '1rem',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            Loading
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Box sx={{ animation: 'dot 1.4s infinite' }}>.</Box>
              <Box sx={{ animation: 'dot 1.4s infinite 0.2s' }}>.</Box>
              <Box sx={{ animation: 'dot 1.4s infinite 0.4s' }}>.</Box>
            </Box>
          </Box>

          <style>
            {`
              @keyframes dot {
                0%, 60%, 100% { opacity: 0; }
                30% { opacity: 1; }
              }
            `}
          </style>
        </Box>
      </Fade>
    </Box>
  );
};

export default LoadingScreen;